import { render, staticRenderFns } from "./SupporterDetails.vue?vue&type=template&id=78e30f9b&scoped=true&"
import script from "./SupporterDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e30f9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e30f9b')) {
      api.createRecord('78e30f9b', component.options)
    } else {
      api.reload('78e30f9b', component.options)
    }
    module.hot.accept("./SupporterDetails.vue?vue&type=template&id=78e30f9b&scoped=true&", function () {
      api.rerender('78e30f9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Details/SupporterDetails.vue"
export default component.exports